import { render, staticRenderFns } from "./VehicleTypeForm.vue?vue&type=template&id=0b246f4e&scoped=true&"
import script from "./VehicleTypeForm.vue?vue&type=script&lang=ts&"
export * from "./VehicleTypeForm.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleTypeForm.vue?vue&type=style&index=0&id=0b246f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b246f4e",
  null
  
)

export default component.exports